import { render, staticRenderFns } from "./myBetsPanel.vue?vue&type=template&id=5401a75a&lang=pug&"
import script from "./myBetsPanel.vue?vue&type=script&lang=js&"
export * from "./myBetsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports